import { FC } from 'react'
import * as styles from 'styles/atoms/AbsentValue.css'

const AbsentValue: FC = (props) => {
  const { children } = props
  return (
    <div data-qa-type='absent-value' className={ styles.absentValue }>
      { children }
    </div>
  )
}

export default AbsentValue
